import { restApi } from '../../api';
import {
  UiPreferenceRecognizedKeys,
  UpdateOrCreateColumnsPreferenceInput,
  UpdateOrCreateFilterPreferenceInput,
  UpdateOrCreateUiPreferenceInput,
  UpdateOrCreateViewPreferenceInput,
  UserContextPreferences,
} from './userContextPreferences.types';

const PATH = 'users/user-context-preferences';

export const findUserContextPreferences = async () => restApi.get<UserContextPreferences>(PATH);

export const updateOrCreateFilterPreference = async ({
  defaultFilters,
  list,
}: UpdateOrCreateFilterPreferenceInput) =>
  restApi.post<UserContextPreferences>(`${PATH}/filter-preferences/${list}`, { defaultFilters });

export const updateOrCreateColumnsPreference = async ({
  list,
  defaultColumns,
}: UpdateOrCreateColumnsPreferenceInput) =>
  restApi.post<UserContextPreferences>(`${PATH}/columns-preference/${list}`, { defaultColumns });

export const updateOrCreateViewPreference = async ({
  defaultView,
}: UpdateOrCreateViewPreferenceInput) =>
  restApi.post<UserContextPreferences>(
    `${PATH}/ui-preferences/${UiPreferenceRecognizedKeys.CATALOG_VIEW}`,
    { value: defaultView },
  );

export const updateOrCreateUiPreference = async ({ key, value }: UpdateOrCreateUiPreferenceInput) =>
  restApi.post<UserContextPreferences>(`${PATH}/ui-preferences/${key}`, { value });
